import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface VisitCancelReasonCodes {
  visitCancelReasonCodes: { code: string; label: string; display: string }[];
}

export const useVisitCancelReasonCodes = () => {
  return useApi<VisitCancelReasonCodes>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<VisitCancelReasonCodes>(
          "/amazon-clinic/visits/cancel-reason-codes",
        );
        return response.data;
      },
      queryKey: QueryKeys.Patient.Chart.VISIT_CANCEL_REASON_CODES,
      staleTime: Number.POSITIVE_INFINITY,
    },
  });
};
